import { CircleCheck, CircleOff, ClockAlert, LoaderCircle } from 'lucide-react';
import type { Device } from '../types';
import { getCameraPresentationStatus } from '../utils/cameraStatus';

const icons = {
  online: CircleCheck,
  offline: CircleOff,
  checking: LoaderCircle,
  stale: ClockAlert,
};

export function CameraOverallBadge({ device, compact = false }: { device: Device; compact?: boolean }) {
  const status = getCameraPresentationStatus(device);
  const isReserved = device.camera?.isReservedChannel ?? false;
  const Icon = isReserved ? CircleOff : icons[status.state];
  return (
    <span className={`status-badge status-badge--${isReserved ? 'disabled' : status.state} ${compact ? 'status-badge--compact' : ''}`}>
      <Icon className={!isReserved && status.state === 'checking' ? 'spin' : undefined} size={14} strokeWidth={2.2} aria-hidden="true" />
      <span>{isReserved ? 'Резервный канал' : status.label}</span>
    </span>
  );
}
